module.exports = __webpack_public_path__ + "img/dcmm_25.7bd4a9a2.png";